/**
 * Popular categories — progress-bar carousel navigation (mobile).
 * Mirrors slideshow contained carousel navigation behavior.
 */
function updatePopularCategoriesNavigation(nav, index) {
  const count =
    parseInt(nav.dataset.slideCount, 10) ||
    nav.querySelectorAll('.popular-categories__navigation-segment').length;

  if (!count) return;

  nav.style.setProperty('--popular-categories-nav-progress', (index + 1) / count);
}

function initPopularCategoriesNavigation(nav) {
  if (nav.dataset.mmkNavInit === 'true') return;
  nav.dataset.mmkNavInit = 'true';

  const carousel = document.getElementById(nav.getAttribute('aria-controls'));
  if (!carousel) return;

  const segments = nav.querySelectorAll('.popular-categories__navigation-segment');
  const selectedIndex = Array.from(segments).findIndex(
    (button) => button.getAttribute('aria-current') === 'true'
  );

  updatePopularCategoriesNavigation(nav, Math.max(selectedIndex, 0));

  carousel.addEventListener('carousel:change', (event) => {
    updatePopularCategoriesNavigation(nav, event.detail.index);
  });
}

function initPopularCategoriesNavigations(root = document) {
  root.querySelectorAll('.popular-categories__navigation').forEach(initPopularCategoriesNavigation);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initPopularCategoriesNavigations());
} else {
  initPopularCategoriesNavigations();
}

document.addEventListener('shopify:section:load', (event) => {
  initPopularCategoriesNavigations(event.target);
});
